import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import Loader from '../../components/loader';

const Dashboard = lazy(() => import('../../container/dashboard'));
const EmployeeList = lazy(() => import('../../container/list-employee'));
const Request = lazy(() => import('../../container/users/requests/request-actions'));
const Employee = lazy(() => import('../../container/users/employees/request-actions'));

const Admin = () => {
  const { path } = useRouteMatch();
  const fallback = () => {
    return (
      <div className="spin">
        <Spin />
      </div>
    );
  };

  return (
    <>
      <Loader />
      <Switch>
        <Suspense fallback={fallback()}>
          <Route exact path={`${path}`} component={Dashboard} />
          <Route path={`${path}/employees`} component={EmployeeList} />
          <Route path={`${path}/employee/:id`} component={Employee} />
          <Route path={`${path}/request`} component={Request} />
          <Route path={`${path}/authorizations`} component={Request} />
          <Route path={`${path}/remote`} component={Request} />
        </Suspense>
      </Switch>
    </>
  );
};

export default withAdminLayout(Admin);
